// The public guides are complete HTML. Load the interactive checker only when
// it approaches the viewport, keeping React off the initial hero render path.
const nodes=document.querySelectorAll('[data-region-checker]');
const mount=(node:Element)=>import('./region-mount').then(module=>module.mountRegion(node)).catch(()=>{
 // Keep the server-rendered coverage answer if the enhancement cannot load.
});
if('IntersectionObserver' in window){
 const observer=new IntersectionObserver(entries=>{
  for(const entry of entries)if(entry.isIntersecting){observer.unobserve(entry.target);void mount(entry.target);}
 },{rootMargin:'200px'});
 nodes.forEach(node=>observer.observe(node));
}else nodes.forEach(node=>void mount(node));
